import { jsx as _jsx } from "react/jsx-runtime";
import './Loader_Score.scss';
export const Loader_Score = () => {
    return _jsx("div", { className: 'loader__score' });
};
//# sourceMappingURL=Loader_Score.js.map